import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '../../Typography';
import { styled } from '@mui/material/styles';
const LegendLabel = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'color'
})(({ color }) => ({
    "&::before": {
        display: "inline-block",
        height: "12px",
        width: "12px",
        content: "''",
        borderRadius: "50%",
        backgroundColor: color,
        marginRight: "8px",
    },
    color: 'inherit'
}));
function PieChartLegend({ label, legendColor }) {
    return (_jsx(LegendLabel, Object.assign({ variant: 'subtitle2', sx: { textTransform: "capitalize" }, clamp: 1, color: legendColor }, { children: label })));
}
export default PieChartLegend;
